var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0158 12.7514C11.5605 13.055 11.0316 13.2154 10.4863 13.2154C9.9411 13.2154 9.41223 13.055 8.95693 12.7514L1.45779 7.75186C1.41618 7.72412 1.37565 7.69521 1.33594 7.66547V15.8578C1.33594 16.7971 2.09817 17.5425 3.02065 17.5425H17.952C18.8913 17.5425 19.6367 16.7803 19.6367 15.8578V7.66543C19.5969 7.69524 19.5563 7.72423 19.5146 7.752L12.0158 12.7514Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0526 6.85957L9.55174 11.8592C9.83562 12.0485 10.161 12.1431 10.4863 12.1431C10.8117 12.1431 11.137 12.0484 11.4209 11.8592L18.9201 6.85957C19.3688 6.56058 19.6367 6.06016 19.6367 5.52008C19.6367 4.59142 18.8812 3.83594 17.9526 3.83594H3.02008C2.09145 3.83597 1.33594 4.59145 1.33594 5.52097C1.33594 6.06016 1.60387 6.56058 2.0526 6.85957Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.442e225972fac36b20bf78d372d59c43.svg";
export { ForwardRef as ReactComponent };